import { createPaymentIntentEndpoint } from "constants/stripe";


const homeUrl = process.env.REACT_APP_PATHS_HOME_URL  ?? "";
const homeNewUrl = process.env.REACT_APP_PATHS_NEW_HOME_URL ?? "";
const chainlitUrl = process.env.REACT_APP_PATHS_CHAINLIT_URL ?? "";
const defaultGeoAiApiRoot = process.env.REACT_APP_DEFAULT_GEO_AI_API_ROOT ?? "https://stg.etiquettedpe.fr";

export const paths = {
  mockData() {
    return `https://pst2ptf774f5e6tabql7g4tle40dyetm.lambda-url.eu-west-1.on.aws`;
  },
  modalData() {
    return `https://tnorlolbmzkwo6gxf5u5awukke0senxc.lambda-url.eu-west-1.on.aws`;
  },
  autoCompleteSearch(search: string) {
    return `https://data.geopf.fr/geocodage/search/?q=${search}`;
  },
  listingTable() {
    return "https://akwaiji6qo3z5qy2tyeq4amvh40uhqfc.lambda-url.eu-west-1.on.aws";
  },
  getDataUpload(fileName: string) {
    return `https://p4sbvehmmgattnhkhumlxk5faq0wtztu.lambda-url.eu-west-3.on.aws/?file_name=${fileName}`;
  },
  getRefAdemeFromDataUpload() {
    return `https://pjin5hsqtye23gtcd55pz4zc7e0rfsvg.lambda-url.eu-west-3.on.aws/`;
  },
  getHomeUploadData() {
    return `${homeUrl}/home`;
  //  return `https://dev.etiquettedpe.fr/cd/api/v1/dpes/home`;
  },
  getResultat(refAdeme: string) {
    return `${homeNewUrl}/svg_result/${encodeURIComponent(refAdeme)}`;
  },
  getGEOMap() {
    return "https://gist.githubusercontent.com/wavded/1200773/raw/e122cf709898c09758aecfef349964a8d73a83f3/sample.json";
  },
  submitResultat() {
    return `${homeUrl}/submit`;
  },
  getDataFiabilite() {
    return `${homeUrl}/reliability`;
  },
  getDataFiabiliteSummary() {
    return `${homeUrl}/reliability/summary`;
  },
  getSVGFiabilite() {
    return `${homeUrl}/svg_reliability`;
  },
  getResultAutocomplete() {
    return `${homeUrl}/search_dpes_map`;
  },
  getReCalCulateResult() {
    return "https://vwpw34wpop5cbyr22frtfoppzy0nzlxl.lambda-url.eu-west-1.on.aws/?id=dd";
  },
  getControlsResult() {
    return "https://api-d.ledpe.fr/backoffice/dpe_list";
  },
  postSelectedRowControl() {
    return "https://api-d.ledpe.fr/backoffice/send";
  },
  sendDataControl(control: string) {
    return `https://api-d.ledpe.fr/backoffice/${control}`;
  },
  searchDpesMap() {
    return `${homeUrl}/search_dpes_map`;
  },
  searchAiDpesMap() {
    return `${defaultGeoAiApiRoot}/cd/api/v1/map/ai`;
  },
  searchAiFrameDpesMap() {
    return "https://stg.etiquettedpe.fr/cd/api/v1/map/ai";
  },
  searchAddressDpesMap() {
    return "https://dev.etiquettedpe.fr/cd/api/v1/map/address";
  },
  narrowToAddress() {
    return "https://dev.etiquettedpe.fr/cd/api/v1/map/narrow-to-address";
  },
  chainlit() {
    // return "https://chainlit27389273892738927hdjhceziuhdcez7837298.ledpe.fr/";
    return `${chainlitUrl}/chainlit`;
  },
  getSuggestionRenovation() {
    return `${homeUrl}/suggested_renovation`;
  },
  getGraphePrice() {
    return `${homeUrl}/svg_budget`;
  },
  chatInit() {
    return `${homeUrl}/chat_init`;
  },
  getAccount() {
    return `${homeUrl}/account`;
  },
  getReliabilityRenovation(query: string) {
    return `${homeUrl}/reliability_renovation?q=${query}`;
  },
  getHomeContext() {
    return `${homeUrl}/context`;
  },
  getHomeContextStatus() {
    return `${homeUrl}/context_status`;
  },
  getHomePreload() {
    return `${homeUrl}/preload`;
  },
  postStripePaymentIntent() {
    return `${createPaymentIntentEndpoint}`;
  },
  getDynamicInformationResultat() {
    return `${homeUrl}/information`;
  },
  closeAlertTopACK() {
    return `${homeUrl}/ack_banner`;
  },
  ackOverlayPackage() {
    return `${homeUrl}/ack_token`;
  },
  getSvgLeakage() {
    return `${homeUrl}/svg_leakage`;
  },
  getConfigEditionPanel() {
    return `${homeUrl}/template_interact_v2`;
  },
  updateConfigEditionPanel() {
    return `${homeNewUrl}/templates/interact`;
  },
  codeValidate() {
    return `${homeUrl}/code_validate`;
  },
  getRenovationGraph() {
    // return `${homeUrl}/svg_result_renovation`;
    return `${homeUrl}/svg_result`;
  },
  getProjects() {
    return `${homeNewUrl}/projects/`;
  },
  getMaintenance() {
    return `${homeNewUrl}/utils/maintenance`;
  }
};
